import { render } from "./AdvancedCapabilitiesPage.vue?vue&type=template&id=74a9e1a6&scoped=true"
import script from "./AdvancedCapabilitiesPage.vue?vue&type=script&lang=js"
export * from "./AdvancedCapabilitiesPage.vue?vue&type=script&lang=js"

import "./AdvancedCapabilitiesPage.vue?vue&type=style&index=0&id=74a9e1a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a9e1a6"]])

export default __exports__